<template>
    <app-layout :title="trans('users.page_title.index')">
        <template #header> {{ trans("users.page_title.index") }} </template>

        <Section>
            <Container>
                <div class="mb-8 flex justify-between space-x-2">
                    <Link :href="route('users.create')">
                        <StyledButton background-primary>
                            {{ trans("users.page_title.create") }}
                        </StyledButton>
                    </Link>
                    <div>
                        <input
                            @input="filter"
                            v-model="query"
                            type="search"
                            class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full border-gray-300 rounded-md"
                            placeholder="Suchen..."
                        />
                    </div>
                </div>

                <div>
                    <v-server-table
                        :options="options"
                        :url="route('api.users.index')"
                        :columns="columns"
                        ref="table"
                    >
                        <template v-slot:actions="props">
                            <user-actions
                                :data="props.row"
                                :index="props.index"
                                @refresh="$refs.table.getData()"
                            ></user-actions>
                        </template>
                    </v-server-table>
                </div>
            </Container>
        </Section>
    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import UserActions from "@/Pages/Users/UserActions.vue";
import { Link } from "@inertiajs/inertia-vue3";
import { LockClosedIcon } from "@heroicons/vue/outline";
import Container from "@/Components/Container.vue";
import Section from "@/Components/Section.vue";
import StyledButton from "@/Components/StyledButton.vue";

export default {
    components: {
        AppLayout,
        UserActions,
        Link,
        LockClosedIcon,
        Container,
        Section,
        StyledButton,
    },

    data() {
        return {
            query: null,
            debouncedFilter: null,
            columns: ["fullname", "email", "actions"],
            options: {
                headings: {
                    fullname: this.trans("users.table.name"),
                    email: this.trans("users.table.email"),
                    actions: this.trans("vuetables.label.actions"),
                },

                texts: {
                    count: this.trans("vuetables.label.countText"),
                    filter: this.trans("vuetables.label.filter"),
                    noResults: this.trans("vuetables.label.noResults"),
                    loading: this.trans("vuetables.label.loading"),
                    filterPlaceholder: this.trans("vuetables.label.search"),
                },

                sortable: ["fullname"],

                columnsDisplay: {
                    email: "min_tabletP",
                },
            },
        };
    },

    methods: {
        filter() {
            this.debouncedFilter();
        },
    },

    mounted() {
        this.debouncedFilter = _.debounce(() => {
            this.$refs.table.setFilter(this.query);
        }, 300);
    },
};
</script>
